import { TRegion } from '@cbo/shared-library';
import { UserPreferencesRegion } from '@ncr-voyix-commerce/react-common-components';
import countryAndRegionData from '../../../countryAndRegionData';

const getRegionsByCountry = (countryName: string | undefined) => {
  const countryObject = countryAndRegionData.find((currentCountry) => currentCountry.countryName === countryName);
  return countryObject?.regions || [];
};

export default getRegionsByCountry;

export const mapBSLRegionToASMRegion = (region: UserPreferencesRegion): TRegion => {
  switch (region) {
    case 'UnitedStates':
      return 'en-US';
    case 'Mexico':
      return 'es-MX';
    case 'Canada':
      return 'fr-CA';
    default:
      return 'en-US';
  }
};
